<template>
  <template v-if="!isFiltered">
    <div class="card" :class="horzClasses" v-for="event in filteredEventsData"
         :key="event.eventName">
      <Event :event="event" :hostname="hostname" :eventDetails="eventDetails"/>
    </div>
  </template>
  <template v-else>
    <div class="glide" ref="carousel">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide teaser" v-for="event in filteredEventsData"
              :key="event.eventName">
            <article class="card h-100" :class="vertClasses">
              <Event :event="event" :hostname="hostname" :eventDetails="eventDetails"/>
            </article>
          </li>
        </ul>
      </div>

      <div data-glide-el="controls" v-if="filteredEventsData.length > itemsToShow">
        <button class="fass fa-angle-left slider__arrow slider__arrow--prev glide__arrow glide__arrow--prev"
                :aria-label="previousText" data-glide-dir="<"></button>
        <button class="fass fa-angle-right slider__arrow slider__arrow--next glide__arrow glide__arrow--next"
                :aria-label="nextText" data-glide-dir=">"></button>
      </div>

      <div class="glide-bullets cmp-carousel__item" v-if="filteredEventsData.length > itemsToShow"
           data-glide-el="controls[nav]">
        <button v-for="(item, index) in filteredEventsData"
                :id="`${makeId(item)}-tab`" class="carousel-indicator opacity-75"
                @click="glide.go(`=${index}`)" :class="showClass(index)"
                role="tab" :aria-controls="`${makeId(item)}-tabpanel`"
                :aria-label="`${i18n.get('Slide')} ${item.index + 1}`"></button>

      </div>

    </div>
  </template>
</template>


<script setup>
import {ref, onMounted, nextTick} from 'vue';
import {i18n} from 'base/js/i18n';
import Event from './Event.vue';
import { Glide, getDefaultOptions, getDefaultModules } from 'base/js/templates/general/carouselUtils.js';

// Refs, injections, and translations
const carousel = ref(null);
const eventDetails = i18n.get("Event Details");
const previousText = i18n.get("Previous");
const nextText = i18n.get("Next");
const props = defineProps({
  events: {
    type: Object,
    required: true
  },
  isFiltered: {
    type: Boolean,
    required: false,
    default: false
  }
});


// Constants
const hostname = window.location.hostname;
const yesterday = new Date(Date.now());
yesterday.setDate(yesterday.getDate() - 1);
const vertClasses = 'p-0';
const horzClasses = 'g-0 mb-3 border-0 horizontal-event';
const itemsToShow = ref(4);
const buttonsToShow = ref(0);
let glide = null;

// Filter events to show only upcoming or alwaysShow events
let filteredEventsData = props.events.items.filter(item => ((new Date(item.endDate) > yesterday) || item.alwaysShow === 'true'));

// On the 'All Events' page (non-filtered view), hide events marked to be excluded.
// This assumes that !props.isFiltered means we are on the 'All Events' page.
if (!props.isFiltered) {
  filteredEventsData = filteredEventsData.filter(item => !item.hideFromAllPage);
}

// If we're showing a carousel, initialize that thing
function initCarousel() {
  const el = carousel.value;

  glide = new Glide(el, getDefaultOptions());
  glide.on('mount.after', () => {
    itemsToShow.value = glide.settings.perView;
  });
  glide.on('resize', () => {
    itemsToShow.value = glide.settings.perView;
    // Hide extra buttons that wouldn't work anyway.
    buttonsToShow.value = filteredEventsData.length - (itemsToShow.value - 1);
    // Switch to first slide again to avoid weirdness.
    glide.go('=0');
  });
  glide.mount(getDefaultModules());
}

// Only show if we're on a filtered events page and there are events to show
onMounted(() => nextTick(() => {
  if (props.isFiltered) {
    initCarousel();
    buttonsToShow.value = filteredEventsData.length - (itemsToShow.value - 1);
  }
}));

// Give each item a unique ID so we can control it.
function makeId(event) {
  return `event-${event.startDate}-${event.endDate}`;
}

// Hide buttons that would navigate to blank slides.
function showClass(index) {
  return buttonsToShow.value < (index + 1) ? 'd-none' : '';
}

</script>
